<h5 translate>You have images missing an alt attribute.</h5>
<p translate>We recommend that you have an alt attribute with relevant content on all image tags.</p>
<p translate>Be aware that an empty alt attribute may be sufficient and appropriate for decorative images.</p>
